import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell, LabelList } from 'recharts';

// Data for Chart 2 (Top Right)
const dataAssignedVsOthers = [
    { name: 'You', value: 130 }, // Blue
    { name: 'Others', value: 380 }, // Blue but longer? Wait image shows "Assigned to Me vs Others" as separate horizontal bars?
    // Actually the image Top Right shows "You" (bar) and maybe "Total" or something?
    // Let's look closely at image. "Assigned to Me vs Others". Two horizontal bars. "120" (Top) and "100" (Bottom)?
    // Wait, the labels are cut off. It looks like a horizontal bar chart.
    // Let's assume comparisons.
];

// Data for Chart 3 (Bottom Left)
const dataAssignmentRatio = [
    { name: 'Others', me: 24, others: 76 },
];

// Data for Chart 4 (Bottom Right)
const dataMonthlyAssignments = [
    { name: 'Jan', me: 450, others: 150 },
    { name: 'Feb', me: 430, others: 140 },
    { name: 'Mar', me: 410, others: 130 },
    { name: 'Apr', me: 400, others: 120 },
    { name: 'May', me: 390, others: 110 },
    { name: 'Jun', me: 380, others: 100 },
];

const AssignmentAnalysisChart = () => {
    return (
        <div className="w-full h-[350px]">
            <div className="grid grid-cols-[30%_70%] gap-4 h-full">
                {/* Bottom Left: Assignments to Me vs Others (Stacked Vertical) */}
                <div className="flex flex-col">
                    <h3 className="text-xs font-bold text-gray-800 mb-2">Assignments to Me vs Others</h3>
                    <div className="flex-grow">
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart
                                data={dataAssignmentRatio}
                                margin={{ top: 10, right: 10, left: 10, bottom: 0 }}
                                barSize={40}
                            >
                                <XAxis dataKey="name" tick={{ fontSize: 10 }} axisLine={true} tickLine={false} />
                                <YAxis hide />
                                <Tooltip cursor={{ fill: 'transparent' }} />
                                <Bar dataKey="me" stackId="a" fill="#93C5FD" >
                                    <LabelList dataKey="me" position="center" formatter={() => "24%"} style={{ fill: '#1F2937', fontSize: '12px' }} />
                                </Bar>
                                <Bar dataKey="others" stackId="a" fill="#E5E7EB" radius={[4, 4, 0, 0]}>
                                    <LabelList dataKey="others" position="center" formatter={() => "76%"} style={{ fill: '#374151', fontSize: '12px' }} />
                                </Bar>
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </div>

                {/* Bottom Right: Assigned to Me vs Others by Month (Stacked) */}
                <div className="flex flex-col">
                    <h3 className="text-xs font-bold text-gray-800 mb-2 text-center">Assigned to Me vs. Others by Month</h3>
                    <div className="flex-grow">
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart
                                data={dataMonthlyAssignments}
                                margin={{ top: 10, right: 0, left: -20, bottom: 0 }}
                                barSize={40}
                            >
                                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                <XAxis dataKey="name" tick={{ fontSize: 9 }} axisLine={false} tickLine={false} interval={0} />
                                <YAxis tick={{ fontSize: 9 }} axisLine={false} tickLine={false} />
                                <Tooltip cursor={{ fill: 'transparent' }} />
                                <Bar dataKey="me" stackId="a" fill="#93C5FD" />
                                <Bar dataKey="others" stackId="a" fill="#E5E7EB" radius={[4, 4, 0, 0]} />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default AssignmentAnalysisChart;
